import { render, staticRenderFns } from "./groupTypesList.vue?vue&type=template&id=77621e74&"
import script from "./groupTypesList.vue?vue&type=script&lang=js&"
export * from "./groupTypesList.vue?vue&type=script&lang=js&"
import style0 from "./groupTypesList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports